import React, { useState } from "react";
import { FiSmile } from "react-icons/fi";
import VmoModal from "../../Modules/Modal/VmoModal";
import VmoModalHeader from "../../Modules/Modal/VmoModalHeader";
import { allProducts, capitalize, getService } from "../../../helper";
import VmoModalContent from "../../Modules/Modal/VmoModalContent";
import VmoCard from "../../Views/VmoCard/VmoCard";
import VmoCardContent from "../../Views/VmoCard/VmoCardContent";
import VmoLabel from "../../Elements/VmoLabel/VmoLabel";
import VmoButton from "../../Elements/VmoButton/VmoButton";
import VmoDivider from "../../Elements/VmoDivider";
import VmoCardDescription from "../../Views/VmoCard/VmoCardDescription";
import SingleProductModal from "./SingleProductModal";
import PropTypes from "prop-types";
import VmoPlaceholder from "../../Elements/VmoPlaceholder/VmoPlaceholder";
import VmoPlaceholderHeader from "../../Elements/VmoPlaceholder/VmoPlaceholderHeader";
import VmoPlaceholderLine from "../../Elements/VmoPlaceholder/VmoPlaceholderLine";

const VmoProductModal = ({
  isProductLoading = false,
  productModal,
  setShowProductModal,
  productName = "",
  accountProductDetails,
  handleOpenDashBoard = () => null,
  handleProductSubscribe = () => null,
  userRole = "",
  isOpenDashBoardLoading = false,
  isStartFreeTrailLoading = false,
  setSingleProductModal = () => null,
  singleProductModal = false,
}) => {
  const [productData, setProductData] = useState(null);
  const [openProduct, setOpenProduct] = useState("");
  function getLabel(status) {
    if (["trialing", "active"].includes(status)) {
      const label = capitalize(status);
      const color = status === "trialing" ? "orange" : "green";
      return (
        <VmoLabel size="tiny" color={color}>
          {label}
        </VmoLabel>
      );
    }
    return null;
  }
  function getBtn(service, productDetails) {
    if (service === productName) return null;
    const isServiceExits = accountProductDetails.findIndex(
      (d) => d.service === service
    );
    const commonProps = {
      size: "small",
      disabled: isStartFreeTrailLoading || isOpenDashBoardLoading,
    };
    function handleClick() {
      if (isServiceExits > -1) {
        handleOpenDashBoard({ service });
        setOpenProduct(service);
      } else {
        setSingleProductModal(true);
        setProductData(productDetails);
      }
    }

    return (
      <VmoButton
        {...commonProps}
        size="small"
        primary
        className={isServiceExits > -1 && `basic-fill-btn`}
        disabled={isStartFreeTrailLoading}
        onClick={handleClick}
        loading={isOpenDashBoardLoading && openProduct === service}
      >
        {isServiceExits > -1 ? `Open Dashboard` : `Start Free Trial`}
      </VmoButton>
    );
  }

  if (singleProductModal) {
    return (
      <SingleProductModal
        {...{
          singleProductModal,
          setSingleProductModal,
          productData,
          handleProductSubscribe,
          userRole,
          isStartFreeTrailLoading,
        }}
      />
    );
  }

  return (
    <VmoModal
      open={productModal}
      onClose={() => setShowProductModal(false)}
      className="vmo-modal product-modal"
      closeIcon
    >
      <VmoModalHeader className="vmoModalHeader">
        Manage Your Veemo Apps
      </VmoModalHeader>
      <VmoModalContent className="vmo-modal-body">
        {isProductLoading &&
          [...allProducts].map((d, i) => (
            <VmoCard fluid key={i}>
              <VmoCardContent className="annoCard product-card">
                <VmoPlaceholder>
                  <VmoPlaceholderHeader image>
                    <VmoPlaceholderLine />
                    <VmoPlaceholderLine />
                  </VmoPlaceholderHeader>
                </VmoPlaceholder>
              </VmoCardContent>
            </VmoCard>
          ))}
        {!isProductLoading &&
          allProducts.map((data, i) => (
            <VmoCard fluid key={i}>
              <VmoCardContent className="annoCard product-card">
                <div className="d-flex mb-2">
                  <h4>
                    <div className="product-card-name">
                      <FiSmile />
                      Veemo {getService(data.service)}
                      <span className="ml-1">
                        {getLabel(
                          accountProductDetails.filter(
                            (d) => d.service === data.service
                          )[0]?.status
                        )}
                      </span>
                    </div>
                  </h4>
                  {getBtn(data.service, allProducts[i])}
                </div>
                <VmoDivider className="my-2" />
                <VmoCardDescription>{data.description}</VmoCardDescription>
              </VmoCardContent>
            </VmoCard>
          ))}
      </VmoModalContent>
    </VmoModal>
  );
};

VmoProductModal.defaultProps = {
  isProductLoading: false,
  productModal: false,
  setShowProductModal: () => null,
  productName: "",
  accountProductDetails: [],
  handleOpenDashBoard: () => null,
  handleProductSubscribe: () => null,
  userRole: "",
  isOpenDashBoardLoading: false,
  isStartFreeTrailLoading: false,
  setSingleProductModal: () => null,
  singleProductModal: false,
};

VmoProductModal.propTypes = {
  isProductLoading: PropTypes.bool,
  productModal: PropTypes.bool.isRequired,
  setShowProductModal: PropTypes.func.isRequired,
  productName: PropTypes.string.isRequired,
  accountProductDetails: PropTypes.array.isRequired,
  handleOpenDashBoard: PropTypes.func,
  handleProductSubscribe: PropTypes.func,
  userRole: PropTypes.string.isRequired,
  isOpenDashBoardLoading: PropTypes.bool,
  isStartFreeTrailLoading: PropTypes.bool,
  setSingleProductModal: PropTypes.func.isRequired,
  singleProductModal: PropTypes.bool.isRequired,
};

export default VmoProductModal;
